import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../store/actions/index";

import Breadcrumb from "../../components/Breadcrumb";
import FormOne from "../../components/Hotels/HotelCreate/FormOne";

import { Steps } from "antd";
import moment from "moment";
const { Step } = Steps;

const requiredFields = [
  [
    'hotel_name_1',
    'hotel_name',
    'hotel_code',
    'is_hotel_name',
    'primary_hmg_id',
    'file_location',
    'time_zone',
    'hotel_status',
    'go_live_date',
    'hmg_main_two_id',
    'secondary_hmg_id',
    'hmg_main_three_id',
    'third_hmg_id',
    'hmg_main_four_id',
    'fourth_hmg_id',
    'pos_name',
    'mdo_hotel_email',
    'ss3u_hotel_mapping_name',
    'hmg_list',
    'pms_id',
  ],
  [
    'sign_type',
    'signature_go_live_date',
  ],
  [
    'gm_email',
    'hotel_phone_number',
    'gm_phone',
  ],
];

class HotelCreate extends Component {
  formOneFormRef = React.createRef();
  state = {
    current: 0,
    create: true,
    select: null,
    selectData: null,

  };

  async componentDidMount() {
    if (!this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
    if (!this.props.api.pmsGetData) {
      await this.props.pmsGet();
    }
  }

  excludeReset = () => {
    const fieldsToExclude = ['hotel_name_1'];
    const fieldValues = this.formOneFormRef.current.getFieldsValue();
    const fieldsToReset = Object.keys(fieldValues).filter(
      fieldName => !fieldsToExclude.includes(fieldName)
    );
    this.formOneFormRef.current.resetFields(fieldsToReset);
  };

  customFormRest = () => {
    this.formOneFormRef.current.resetFields(['pms']);
  };

  formOneOnFinish = async (values) => {
    if (this.state.create) {
      if (await this.props.hotelCreate(values)) {
        this.formOneFormRef.current.resetFields();
        this.setState({ current: 0, selectData: undefined });
      }
    } else {
      if (await this.props.hotelUpdate(values)) {
        this.excludeReset();
        this.formOneFormRef.current.resetFields();
        this.setState({ current: 0, selectData: undefined, create : true });
      }
    }

  };

  hotelCodeOneChange = (e) => {
    const { create } = this.state;
    const value = e.target.value;
    if (create) {
      if (process.env.REACT_APP_PLATFORM_TYPE === "MARRIOTT") {
        this.formOneFormRef.current.setFieldsValue({ is_hotel_name: value, ss3u_hotel_mapping_name: value });
      }
      const mdoHotelEmail = `${value.replace(/\s+/g, '').toLowerCase()}@reports.mydigitaloffice.com`;
      this.formOneFormRef.current.setFieldsValue({ mdo_hotel_email: mdoHotelEmail });
    }
  }

  autoCompleteOneChangeFunction = async (value) => {
    if (value === undefined) {
      value = "";
    }
    const result = this.props.api.hotelGetData.data.find(
      (e) => e.hotel_name.toUpperCase() === value.toUpperCase()
    );
    if (result) {
      await this.setState({ create: false, selectData: result });
      let initialValue = null;
      if (this.state.selectData) {
        initialValue = this.state.selectData;
      }
      const hmgList = [];
      const pms = {};

      if (initialValue) {
        if (initialValue.secondary_hmg_main_id && initialValue.secondary_hmg_id) {
          hmgList.push({ hmg_name: initialValue.secondary_hmg_main_id, project_name: initialValue.secondary_hmg_id });
          if (initialValue.third_hmg_main_id && initialValue.third_hmg_id) {
            hmgList.push({ hmg_name: initialValue.third_hmg_main_id, project_name: initialValue.third_hmg_id });
            if (initialValue.fourth_hmg_main_id && initialValue.fourth_hmg_id) {
              hmgList.push({ hmg_name: initialValue.fourth_hmg_main_id, project_name: initialValue.fourth_hmg_id });
            }
          }
        }
        if (initialValue.pms) {
          initialValue.pms.forEach((e) => {
            pms[e.pms_id._id] = e.pms_version;
          });
        }
      }

      this.formOneFormRef.current.setFieldsValue({
        _id: initialValue && initialValue._id ? initialValue._id : null,
        hotel_name:
          initialValue && initialValue.hotel_name
            ? initialValue.hotel_name
            : null,
        hotel_code:
          initialValue && initialValue.hotel_code
            ? initialValue.hotel_code
            : null,
        primary_hmg_id:
          initialValue && initialValue.primary_hmg_id
            ? initialValue.primary_hmg_id
            : null,
        hmg_main_one_id:
          initialValue && initialValue.primary_hmg_main_id
            ? initialValue.primary_hmg_main_id
            : null,
        hmg_list: hmgList,
        is_hotel_name:
          initialValue && initialValue.is_hotel_name
            ? initialValue.is_hotel_name
            : null,
        myp_hotel_name:
          initialValue && initialValue.myp_hotel_name
            ? initialValue.myp_hotel_name
            : null,
        file_location:
          initialValue && initialValue.file_location
            ? initialValue.file_location
            : "S3",
        time_zone:
          initialValue && initialValue.time_zone
            ? initialValue.time_zone
            : null,
        pms_id:
          initialValue && initialValue.pms_id ? initialValue.pms_id : [],
        pms: pms,
        rooms: initialValue && initialValue.rooms ? initialValue.rooms : null,
        hours_of_operation:
          initialValue && initialValue.hours_of_operation
            ? initialValue.hours_of_operation
            : null,
        go_live_date:
          initialValue && initialValue.go_live_date
            ? moment(initialValue.go_live_date, "YYYY-MM-DD")
            : null,
        signature_go_live_date:
          initialValue && initialValue.signature_go_live_date
            ? moment(initialValue.signature_go_live_date, "YYYY-MM-DD")
            : null,
        qc_cutoff:
          initialValue && initialValue.qc_cutoff
            ? moment(initialValue.qc_cutoff, "HH:mm")
            : null,
        sign_type:
          initialValue && initialValue.sign_type
            ? initialValue.sign_type
            : 1,
        hotel_phone_number:
          initialValue && initialValue.hotel_phone_number
            ? initialValue.hotel_phone_number
            : "",
        hotel_address:
          initialValue && initialValue.hotel_address
            ? initialValue.hotel_address
            : null,
        hotel_city:
          initialValue && initialValue.hotel_city
            ? initialValue.hotel_city
            : null,
        hotel_state:
          initialValue && initialValue.hotel_state
            ? initialValue.hotel_state
            : null,
        hotel_country:
          initialValue && initialValue.hotel_country
            ? initialValue.hotel_country
            : null,
        unit_num:
          initialValue && initialValue.unit_num
            ? initialValue.unit_num
            : null,
        primary_contact:
          initialValue && initialValue.primary_contact
            ? initialValue.primary_contact
            : null,
        general_manager:
          initialValue && initialValue.general_manager
            ? initialValue.general_manager
            : null,
        gm_email:
          initialValue && initialValue.gm_email
            ? initialValue.gm_email
            : null,
        gm_phone:
          initialValue && initialValue.gm_phone
            ? initialValue.gm_phone
            : null,
        gm_contact_hours_from:
          initialValue && initialValue.gm_contact_hours_from
            ? moment(initialValue.gm_contact_hours_from, "HH:mm")
            : null,
        gm_contact_hours_to:
          initialValue && initialValue.gm_contact_hours_to
            ? moment(initialValue.gm_contact_hours_to, "HH:mm")
            : null,
        facebook_page_url:
          initialValue && initialValue.facebook_page_url
            ? initialValue.facebook_page_url
            : null,
        google_place_id:
          initialValue && initialValue.google_place_id
            ? initialValue.google_place_id
            : null,
        tripAdvisor_location_id:
          initialValue && initialValue.tripAdvisor_location_id
            ? initialValue.tripAdvisor_location_id
            : null,
        yelp_business_id:
          initialValue && initialValue.yelp_business_id
            ? initialValue.yelp_business_id
            : null,
        qc_type:
          initialValue && initialValue.qc_type
            ? initialValue.qc_type.toString()
            : null,
        qc_schedule:
          initialValue && initialValue.qc_schedule
            ? initialValue.qc_schedule.toString()
            : null,
        enable_triggers:
          initialValue && initialValue.enable_triggers
            ? initialValue.enable_triggers
            : false,
        historical_data:
          initialValue && initialValue.historical_data
            ? initialValue.historical_data
            : false,
        live_in_s3:
          initialValue && initialValue.live_in_s3
            ? initialValue.live_in_s3
            : false,
        hotel_status:
          initialValue && initialValue.hotel_status
            ? initialValue.hotel_status
            : null,
        signature_type:
          initialValue && initialValue.signature_type
            ? initialValue.signature_type
            : undefined,
        qc_hotel_id:
          initialValue && initialValue.qc_hotel_id
            ? initialValue.qc_hotel_id
            : null,
        adhoc_reports_schedule:
          initialValue && initialValue.adhoc_reports_schedule
            ? initialValue.adhoc_reports_schedule
            : null,
        pos: initialValue && initialValue.pos ? "1" : "0",
        pos_name:
          initialValue && initialValue.pos_name ? initialValue.pos_name : [],
        qc_db_create_and_update:
          initialValue && initialValue.qc_db_create_and_update ? "1" : "0",
        mdo_hotel_email:
          initialValue && initialValue.mdo_hotel_email
            ? initialValue.mdo_hotel_email
            : null,
        qc_enable_periodic_update:
          initialValue && initialValue.qc_enable_periodic_update
            ? initialValue.qc_enable_periodic_update
            : false,
        ai_enabled:
          initialValue && initialValue.ai_enabled
            ? initialValue.ai_enabled
            : false,
        serverless_hotel:
          initialValue && initialValue.serverless_hotel
            ? initialValue.serverless_hotel
            : false,
        copy_from_hotel_code:
          initialValue && initialValue.copy_from_hotel_code
            ? initialValue.copy_from_hotel_code
            : undefined,
        qc_enable_periodic_update_rapid:
          initialValue && initialValue.qc_enable_periodic_update_rapid
            ? initialValue.qc_enable_periodic_update_rapid
            : false,
        man_append_to_same_trigger:
          initialValue && initialValue.man_append_to_same_trigger
            ? initialValue.man_append_to_same_trigger
            : false,
        check_for_prv_envelop:
          initialValue && initialValue.check_for_prv_envelop
            ? initialValue.check_for_prv_envelop
            : false,
        pna_hotel:
          initialValue && initialValue.pna_hotel
            ? initialValue.pna_hotel
            : false,
        myp_hotel:
          initialValue && initialValue.myp_hotel
            ? initialValue.myp_hotel
            : false,
        is_enabled:
          initialValue && initialValue.is_enabled
            ? initialValue.is_enabled
            : false,
        ss3u_hotel_mapping_name:
          initialValue && initialValue.ss3u_hotel_mapping_name
            ? initialValue.ss3u_hotel_mapping_name
            : null,
        myp_id:
          initialValue && initialValue.myp_id ? initialValue.myp_id : null,
        no_of_files_expected:
          initialValue && initialValue.no_of_files_expected
            ? initialValue.no_of_files_expected
            : null,
        myp_pms:
          initialValue && initialValue.myp_pms
            ? initialValue.myp_pms
            : undefined,
        myp_str_id:
          initialValue && initialValue.myp_str_id
            ? initialValue.myp_str_id
            : undefined,
        finance_checklist: initialValue?.finance_checklist ?? "parent",
        intellisight_plus:
          initialValue && initialValue.intellisight_plus
            ? initialValue.intellisight_plus
            : false,
        split_by_sub_header: initialValue?.split_by_sub_header ?? "2",
      });
    } else {

      this.setState({ create: true, selectData: null });
      this.excludeReset();
      this.customFormRest();
      this.formOneFormRef.current.setFieldsValue({ hotel_name: value });
      if (process.env.REACT_APP_PLATFORM_TYPE === "GENERIC") {
        this.formOneFormRef.current.setFieldsValue({ is_hotel_name: value, ss3u_hotel_mapping_name: value });
      }
    }
  };

  autoCompleteOneSelect = async (value, option) => {
  };

  autoCompleteOneChange = async (value, label) => {
    await this.autoCompleteOneChangeFunction(value);
  };

  next = async () => {
    try {
      const { current } = this.state;
      await this.formOneFormRef.current.validateFields(requiredFields[current] ? requiredFields[current] : []);
      this.setState({ current: current + 1 });
    } catch (e) {
      console.log(e);
    }
  };

  prev = () => {
    const current = this.state.current - 1;
    this.setState({ current });
  };
  render() {
    const { current } = this.state;

    const steps = [
      {
        title: "GENERAL INFORMATION",
        content: "First-content",
      },
      {
        title: "SIGNATURE SETTINGS",
        content: "First-content",
      },
      {
        title: "CONTACT INFORMATION",
        content: "Second-content",
      },
      {
        title: "ADDITIONAL INFORMATION",
        content: "Additional Information",
      },
    ];

    return (
      <div>
        <div className="container_aa">
          <h3>Hotel Create and Update</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "hotel-create",
                breadcrumbName: "Hotel Create and Update",
              },
            ]}
          />
        </div>

        <div className="container_ab">
          <div className="container_style_2">
            <div>
              <Steps current={current}>
                {steps.map((item) => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>

              <div style={{ marginBottom: 20 }}></div>

              <div className="steps-content">
                {this.props.api.hotelGetData &&
                  this.props.api.hmgGetData &&
                  this.props.api.pmsGetData &&
                  this.props.api.hmgMainGetData ? (
                  <FormOne
                    formRef={this.formOneFormRef}
                    onFinish={this.formOneOnFinish}
                    hotelGetData={this.props.api.hotelGetData.data}
                    hmgGetData={this.props.api.hmgGetData.data}
                    hmgMainGetData={this.props.api.hmgMainGetData.data}
                    pmsGetData={this.props.api.pmsGetData.data}
                    autoCompleteOneChange={this.autoCompleteOneChange}
                    autoCompleteOneSelect={this.autoCompleteOneSelect}
                    createStatus={this.state.create}
                    current={current}
                    next={this.next}
                    prev={this.prev}
                    steps={steps}
                    initialValue={this.state.selectData}
                    hotelCodeOneChange={this.hotelCodeOneChange}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hotelGet: () => dispatch(actions.hotelGet()),
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  pmsGet: () => dispatch(actions.pmsGet()),

  hotelCreate: (data) => dispatch(actions.hotelCreate(data)),
  hotelUpdate: (data) => dispatch(actions.hotelUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HotelCreate);
